import { ExcelGridCellCommit } from "../../../../../shared/excel-grid/models/excel-grid.models";

export const certificatesSettingsValueClass = "font-semibold text-gray-500 dark:text-gray-400";

export const noopCellCommit = (_commit: ExcelGridCellCommit) => undefined;

export function formatCellValue(value: unknown): string {
  if (value === undefined || value === null) {
    return "";
  }

  return String(value);
}
